import useDOMEvent from "helpers/useDOMEvent";
import React, { createContext, useState } from "react";

export const SUPPORT_FULLSCREEN = !!document.body.requestFullscreen;

export const fullscreenStateContext = createContext();

export default function FullscreenStateProvider({ children }) {
  const [fullscreen, fullscreenSetRaw] = useState(() => !!document.fullscreenElement);

  useDOMEvent(
    "fullscreenchange",
    () => {
      if (SUPPORT_FULLSCREEN) fullscreenSetRaw(!!document.fullscreenElement);
    },
    () => document,
  );

  const fullscreenSet = (value) => {
    if (SUPPORT_FULLSCREEN) {
      if (value) {
        document.body.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    } else fullscreenSetRaw(value);
  };

  return (
    <fullscreenStateContext.Provider value={{ fullscreen, fullscreenSet }}>{children}</fullscreenStateContext.Provider>
  );
}
